import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import passwordVerification from '../components/passwordVerification.js';

const UserSettings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    setContext('Settings');
    const [user, setUser] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [loading, setLoading] = useState(id ? true : false);
    const [file, setFile] = useState(null);
    const [fp, setFP] = useState('');
    const [deleteImage, setDeleteImage] = useState(false);
    const loadUser = () => {
        axios.post(process.env.REACT_APP_API_URL + 'user').then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                console.log(r.data.results);
                setUser(r.data.results);
            }
        });
    }
    useEffect(() => {
        loadUser()
    }, []);
    const setValue =(key, value) => {
        setUser(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const verify = () => {
        if (user.firstName == '') {
            toast.error("Please include your first name.");
            return false;
        }
        if (user.lastName == '') {
            toast.error("Please include your last name.");
            return false;
        }
        if (!user.email.match(/^[\w\.-]+@[\w\.-]+\.\w+$/)) {
            toast.error("Please include a valid email.");
            return false;
        }
        return true;
    }
    const save = () => {
        if (!verify()) {
            return;
        }
        axios.post(process.env.REACT_APP_API_URL + 'user/update', {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            metaData: JSON.stringify(user.metaData || {})
        }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    localStorage.setItem('jwt', r.data.token);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                }
            });
    }
    const verifyPassword = () => {
        if (oldPassword == '') {
            toast.error("Please enter your current password.");
            return false;
        }
        var pMsg = passwordVerification(newPassword)
        if (pMsg) {
            toast.error(pMsg);
            return false;
        }
        if (newPassword != confirmPassword) {
            toast.error("Please confirm your password.");
            return false;
        }
        return true;
    }
    const updatePassword = () => {
        if (!verifyPassword()) {
            return;
        }
        /*const formData = new FormData();
        formData.append('oldPassword', oldPassword);
        formData.append('newPassword', newPassword);*/
        axios.post(process.env.REACT_APP_API_URL + 'sponsor/add', {
            oldPassword,
            newPassword
        }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                }
            });
    }
    if (loading || !user) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <h2 className="mb-10 w-100">Settings</h2>
                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <h3 className="mb-10">User Info</h3>
                        <div className="w-100 gap-10 f-row f-wrap">
                            <div className="w-50 w-xs-100">
                                <label htmlFor="fname">First Name</label>
                                <input type="text" id="fname" value={user.firstName} onChange={(e) => setValue('firstName', e.target.value)} />
                            </div>
                            <div className="w-50 w-xs-100">
                                <label htmlFor="fname">Last Name</label>
                                <input type="text" id="fname" value={user.lastName} onChange={(e) => setValue('lastName', e.target.value)} />
                            </div>
                            <div className="w-50 w-xs-100">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" value={user.email} readOnly />
                            </div>
                        </div>

                        <div className="w-100 f-end f-row mt-10">
                            <div className="flex f-end f-row gap-5">
                                <button onClick={save} className="btn btn-green">Update</button>
                            </div>
                        </div>
                    </div>

                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white">
                        <h3 className="mb-10">Password</h3>
                        <div className="w-100 gap-10 f-row f-wrap">
                            <div className="w-100 w-xs-100">
                                <label htmlFor="oldpassword">Current Password</label>
                                <input type="password" id="oldpassword" autoComplete="new-password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                            </div>
                            <div className="w-100 w-xs-100">
                                <label htmlFor="newpassword">New Password</label>
                                <input type="password" id="newpassword" autoComplete="new-password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                            </div>
                            <div className="w-100 w-xs-100">
                                <label htmlFor="confirmpassword">Confirm Password</label>
                                <input type="password" id="confirmpassword" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                            </div>
                        </div>

                        <div className="w-100 f-end f-row mt-10">
                            <div className="flex f-end f-row gap-5">
                                <button onClick={updatePassword} className="btn btn-green">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default UserSettings;